<nb-card class="accept-card" dir="rtl">
  <nb-card-header class="modal-header">
    <div class="header-title">
      <span class="header-icon">
        <nb-icon icon="credit-card-outline"></nb-icon>
      </span>
      <div>
        <strong>ثبت واریز برداشت</strong>
        <small>جزئیات را بررسی کنید و سپس رسید واریز را ثبت کنید.</small>
      </div>
    </div>

    <div class="header-actions">
      <button
        nbButton
        size="small"
        status="basic"
        type="button"
        (click)="close()"
        [disabled]="loading"
      >
        انصراف
      </button>

      <button
        nbButton
        size="small"
        status="success"
        type="submit"
        form="checkout-accept-form"
        [disabled]="loading || detailLoading || form.invalid"
      >
        <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
        {{ loading ? 'در حال ثبت...' : 'ثبت و تأیید' }}
      </button>
    </div>
  </nb-card-header>

  <form id="checkout-accept-form" [formGroup]="form" (ngSubmit)="submit()">
    <nb-card-body>
      <div *ngIf="detailLoading" class="state-box">
        در حال دریافت جزئیات درخواست...
      </div>

      <ng-container *ngIf="!detailLoading && detail">
        <section class="request-summary mx-4 py-4">
          <div class="amount-block">
            <span>مبلغ قابل واریز</span>
            <strong>{{ detail?.amount || 0 | number }}</strong>
            <small>تومان</small>
          </div>

          <div class="request-status">
            <span class="status-dot"></span>
            {{ statusLabel }}
          </div>
        </section>

        <section class="details-section">
          <div class="section-heading">
            <nb-icon icon="person-outline"></nb-icon>
            <span>اطلاعات درخواست</span>
          </div>

          <div class="info-grid">
            <div class="info-item">
              <span>درخواست‌دهنده</span>
              <strong>{{ requesterName }}</strong>
              <small *ngIf="requesterContact">{{ requesterContact }}</small>
            </div>
            <div class="info-item">
              <span>تاریخ ثبت درخواست</span>
              <strong>{{ createdAtLabel }}</strong>
            </div>
          </div>

          <div class="bank-grid">
            <div class="bank-item">
              <span class="bank-icon">
                <nb-icon icon="credit-card-outline"></nb-icon>
              </span>
              <div>
                <small>شماره کارت مقصد</small>
                <strong class="ltr-value">{{ cardNumber }}</strong>
              </div>
            </div>

            <div class="bank-item">
              <span class="bank-icon">
                <nb-icon icon="hash-outline"></nb-icon>
              </span>
              <div>
                <small>شماره شبای مقصد</small>
                <strong class="ltr-value">{{ sheba }}</strong>
              </div>
            </div>
          </div>

          <div class="description-box">
            <span>توضیحات درخواست</span>
            <p>{{ detail?.description || 'بدون توضیحات' }}</p>
          </div>

          <div class="technical-info">
            <span>
              شناسه درخواست:
              <bdi>{{ detail?.id || detail?._id || '-' }}</bdi>
            </span>
            <span *ngIf="detail?.transaction">
              شناسه تراکنش:
              <bdi>
                {{
                  detail?.transaction?.id ||
                    detail?.transaction?._id ||
                    detail?.transaction
                }}
              </bdi>
            </span>
          </div>
        </section>

        <section class="payment-section">
          <div class="section-heading">
            <nb-icon icon="checkmark-square-2-outline"></nb-icon>
            <div>
              <span>اطلاعات واریز</span>
              <small>کد پیگیری و رسید بانکی را وارد کنید.</small>
            </div>
          </div>

          <div class="form-grid">
            <ngx-input-field
              formControlName="trackingCode"
              label="کد پیگیری پرداخت"
              placeholder="مثلاً ۱۲۳۴۵۶۷۸۹"
              [control]="trackingCodeControl"
              [inputAttrs]="{ dir: 'ltr', maxlength: 100 }"
            ></ngx-input-field>

            <ngx-datepicker-field
              formControlName="paymentDate"
              label="تاریخ پرداخت (اختیاری)"
              placeholder="انتخاب تاریخ پرداخت"
              [control]="paymentDateControl"
              [appendTo]="'body'"
            ></ngx-datepicker-field>

            <div class="receipt-field">
              <ngx-file-uploader
                formControlName="receipt"
                label="رسید پرداخت"
              ></ngx-file-uploader>
              <div
                class="field-error"
                *ngIf="receiptControl?.touched && receiptControl?.invalid"
              >
                انتخاب فایل رسید الزامی است.
              </div>
            </div>
          </div>
        </section>
      </ng-container>
    </nb-card-body>
  </form>
</nb-card>
